module.exports = __webpack_public_path__ + "img/749DCBE9905D3848.4c81512f.png";